import state from './roomGroupState'
import mutations from './roomGroupMutations'
import getters from './roomGroupGetters'
import actions from './roomGroupActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
